export const GENERATED_SUPPORTED_LANGUAGES = [
  "ar",
  "ca",
  "de",
  "en",
  "es",
  "fr",
  "it",
  "pt",
  "zh"
] as const;
